import './index.css'
import Button from '../button';
import { StructureIdea } from '../../functions/structureIdea';
import { fetchStructuredIdea } from '../../functions/fetchStructureIdea';
import { useState } from 'react';

function IdeaItem({date,generatedFrom,title,status,id,display,expandIdea,SetExpandedIdea,handleDeleteRequest,scheduledDate,voices,voiceName}){
    const [renderedStatus,SetRenderedStatus] = useState(status);
    let statusMessage;
    let statusGraph;
    let CTA;
    switch (renderedStatus){
        case 1:
            statusMessage='Generated'
            statusGraph=<><div class="status-widget complete"></div><div class="status-widget"></div></>;
            CTA='View structure'
        break;
        case 2:
            let dateParts = scheduledDate.split(' ');
            let formattedDateString = `${dateParts[2]} ${dateParts[1]} ${dateParts[3]}`; // Convert to '02 Oct 2024' format
            let dateToDisplay = new Date(formattedDateString);
            statusMessage = dateToDisplay.toLocaleDateString();
            statusGraph = <><div class="status-widget complete"></div><div class="status-widget complete"></div></>;
            CTA = 'View structure';
        break;
        
    }

    let displayToSet;
    if(display==='none'){
        displayToSet='flex'
    }
    else{
        displayToSet='none'
    }

    const handleOpenIdea = async(id) => {
        console.log("Opening idea!");
        let structure = await fetchStructuredIdea(id);
            console.log(structure.foundObject);
            await SetExpandedIdea(structure.foundObject);
            expandIdea()
    }

    return <div className='idea-item-border' style={{display:displayToSet}}>
    <div className='idea-item idea'>
    <div className='idea-info-holder'>
    <div className='tiny-text date'>{new Date(date).toDateString()}</div>
    </div>
    <div className='idea-title-holder'><h2>{title}</h2></div>
        <div className="graphic-holder">
    <img className='idea-type-tag' src='../images/blog.png'></img>
        <div className='scheduled-date-expanded'>
        <img className='extra-info-image' src='./images/team.png'></img>
        <div className='value-date small-text'>{voiceName}</div>
    </div>
    </div>
    <div className='info-holder'>
    <div className='status-holder tiny-text'>
        <div className='label'>Status</div>
        <div className='status-graph-holder'>
            {statusGraph}
        </div>
        <div className='value'>{statusMessage}</div>
    </div>
    </div>
    <div className='idea-action-bar'>
    <Button text={CTA} smallBool={true} addedFunction={handleOpenIdea} params={id}/>
    <Button text='Delete' smallBool={true} addedFunction={handleDeleteRequest} params={id}></Button>
    </div>
    </div>
    </div>
}

export default IdeaItem